export enum MerchantUploadDocumentTypeEnum {
    SECDocuments = 1,
    BIR2303Document = 2,
    PersonalIdentification = 3,
    CompanyAuthorizationLetter = 4
}
